import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { PiHouse, PiCreditCard, PiSignOut, PiFileText } from 'react-icons/pi';
import './DashboardLayout.css';

export function DashboardLayout({ children, currentPlan, activeSeatCount, seatsAllowed, statusInfo, title, description }) {
    const location = useLocation();
    const navigate = useNavigate();

    const handleSignOut = async () => {
        await signOut(auth);
        navigate('/login', { replace: true });
    };

    const mainNavItems = [
        { path: '/dashboard', label: 'Overview', icon: <PiHouse size={20} />, exact: true },
        { path: '/dashboard/summaries', label: 'Call Summaries', icon: <PiFileText size={20} /> },
    ];

    const settingsNavItems = [
        { path: '/dashboard/billing', label: 'Plan & Billing', icon: <PiCreditCard size={20} /> },
    ];

    return (
        <div className="layout-shell">
            <aside className="layout-sidebar">
                <Link to="/" className="layout-brand">
                    <span className="brand-primary">Up</span>
                    <span className="brand-accent">Convert</span>
                </Link>
                <p className="layout-label">Workspace Admin</p>

                <nav className="layout-nav" aria-label="Dashboard sections">
                    {mainNavItems.map((item) => {
                        const isActive = item.exact
                            ? location.pathname === item.path || location.pathname === item.path + '/'
                            : location.pathname.startsWith(item.path);

                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`nav-item ${isActive ? 'active' : ''}`}
                            >
                                {item.icon}
                                <span>{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>

                <div style={{ marginTop: 'auto', marginBottom: 24 }}>
                    <p className="layout-label">Settings</p>
                    <nav className="layout-nav" aria-label="Settings sections">
                        {settingsNavItems.map((item) => {
                            const isActive = location.pathname.startsWith(item.path);
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className={`nav-item ${isActive ? 'active' : ''}`}
                                >
                                    {item.icon}
                                    <span>{item.label}</span>
                                </Link>
                            );
                        })}
                    </nav>
                </div>

                <button className="layout-signout" type="button" onClick={handleSignOut}>
                    <PiSignOut size={18} />
                    <span>Sign out</span>
                </button>
            </aside>

            <main className="layout-main">
                <header className="page-header">
                    <p className="page-eyebrow">Control Center</p>
                    <h1 className="page-title">{title}</h1>
                    <p className="page-description">{description}</p>
                </header>

                <div className="page-content">
                    {children}
                </div>
            </main>
        </div>
    );
}
